<template>
  <ul v-show="displayProps" class="CartItem__Options">
    <li
      v-for="(value, key) in props.item.properties"
      v-show="notHidden(key)"
      class="p5"
      data-color="night-sky-dark"
    >
      {{ value }}
    </li>
    <li v-show="hasBMSM && bmsmTier" class="d2" data-color="night-sky-dark">
      {{ bmsmTier }}
    </li>
    <li v-show="isFinalSale" class="d2" data-color="magic-hour-error">
      {{ isFinalSale }}
    </li>
  </ul>
</template>

<script setup>
import { computed } from 'vue';
import { useCartStore } from './Composables/Store';

const store = useCartStore();
const props = defineProps({
  item: Object,
});

const hasProps = computed(() => {
  const keys = Object.keys(props.item.properties);
  const filteredProperties = keys.filter((key) => notHidden(key));
  return filteredProperties.length > 0;
});
const hasBMSM = computed(() => props.item.bmsm_enabled);
const notHidden = (key) => {
  const firstCharacter = key.charAt(0);
  return firstCharacter !== '_' && key != 'Ships';
};

const isFinalSale = computed(() => {
  const tags = props.item.tags;
  return tags.find((tag) => tag == 'Final Sale');
});

const bmsmTier = computed(() => {
  if (!props.item.bmsm_enabled) return false;

  const quantity = parseInt(props.item.group_quantity);
  if (quantity <= 0) return false;

  const tags = props.item.tags;
  const tag = tags
    .filter((tag) => tag.includes('BMSM Tiers'))
    .map((tag) => tag.split(':')[1].trim().split('/'))
    .flat();

  const tiers = tag.reduce((arr, current) => {
    const tier = current.split('-');
    const quantity = tier[0];
    const discount = tier[1];
    arr.push({ quantity: quantity, discount: discount });
    return arr;
  }, []);

  const atLimit = quantity >= tiers.length;
  if (atLimit) return false;

  const tier = tiers[quantity];
  const terms = store.$state.terms.bmsm;
  const message = `${terms.message_start}${tier.discount}${terms.message_end}`;
  return message;
});

const displayProps = computed(() => {
  const hasLineProperties = hasProps.value;
  const lineHasBMSM = hasBMSM.value && bmsmTier.value;
  const finalSale = isFinalSale.value;
  return hasLineProperties || finalSale || lineHasBMSM;
});
</script>
